import type { AllRouteEndpoints } from "../routeTypes";

export const postAppGroupIdBrazeDocsFallbackSearchCacheKeys: AllRouteEndpoints[] = [];
